module.exports = __webpack_public_path__ + "static/media/DSCF6381_ENTREGAJUANSANCHEZ_290.eb1858c7.jpg";